
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import MyCourse from './classroom/views/MyCourse/index.vue'
import MyStudy from './classroom/views/MyStudy/index.vue'
import MyAccount from './classroom/views/MyAccount/index.vue'
import MyCalendar from './classroom/views/MyCalendar/index.vue'
import Experience from './classroom/views/Experience/index.vue'
import Book from './classroom/views/Book/index.vue'
import HeaderUserPanel from './classroom/views/HeaderUserPanel/index.vue'
import StudyRecord from './classroom/views/StudyRecord/index.vue'
import type { MyClassroomType } from '@xt/client/entities/my-v2/types'

@Observer
@Component({
  components: {
    MyCourse,
    MyStudy,
    MyAccount,
    MyCalendar,
    Experience,
    StudyRecord,
    Book,
    HeaderUserPanel
  }
})
export default class MyClassroom extends Vue {
  experienceData: MyClassroomType['Experience'] = { count: 0, level: 0, progress: 0, sumexperience: 0 }

  get UserStore() {
    return this.$store.$storeUser
  }

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  init(): void {
    this.MyClassroomStore.fetchUserPanelData()
    this.MyClassroomStore.fetchStudyRecordData()
    this.MyClassroomStore.LoadMyProductList()
    this.MyClassroomStore.LoadMyStudyData()
    this.MyClassroomStore.LoadGiftList()

    this.experienceData = {
      count: this.UserStore.count,
      progress: this.UserStore.progress,
      sumexperience: this.UserStore.sumexperience[this.UserStore.level + 1],
      level: this.UserStore.level
    }
  }

  created(): void {
    this.init()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
